var AlbumTrackThumbnail      = require("app/ui/thumbnails/AlbumTrackThumbnail"),
    ArtistThumbnail          = require("app/ui/thumbnails/ArtistThumbnail"),
    AudioThumbnail           = require("app/ui/thumbnails/AudioThumbnail"),
    BookThumbnail            = require("app/ui/thumbnails/BookThumbnail"),
    BrandThumbnail           = require("app/ui/thumbnails/BrandThumbnail"),
    CategoryThumbnail        = require("app/ui/thumbnails/CategoryThumbnail"),
    EpisodeThumbnail         = require("app/ui/thumbnails/EpisodeThumbnail"),
    ExternalThumbnail        = require("app/ui/thumbnails/ExternalThumbnail"),
    IssueThumbnail           = require("app/ui/thumbnails/IssueThumbnail"),
    MagazineThumbnail        = require("app/ui/thumbnails/MagazineThumbnail"),
    MusicAlbumThumbnail      = require("app/ui/thumbnails/MusicAlbumThumbnail"),
    PageThumbnail            = require("app/ui/thumbnails/PageThumbnail"),
    PhotoThumbnail           = require("app/ui/thumbnails/PhotoThumbnail"),
    PlaylistThumbnail        = require("app/ui/thumbnails/PlaylistThumbnail"),
    PodcastThumbnail         = require("app/ui/thumbnails/PodcastThumbnail"),
    PodcastEpisodeThumbnail  = require("app/ui/thumbnails/PodcastEpisodeThumbnail"),
    ProductCategoryThumbnail = require("app/ui/thumbnails/ProductCategoryThumbnail"),
    ProductThumbnail         = require("app/ui/thumbnails/ProductThumbnail"),
    SeriesThumbnail          = require("app/ui/thumbnails/SeriesThumbnail"),
    ThumbnailPlaceholder     = require("app/ui/thumbnails/ThumbnailPlaceholder"),
    VideoThumbnail           = require("app/ui/thumbnails/VideoThumbnail"),
    ViewMoreThumbnail        = require("app/ui/thumbnails/ViewMoreThumbnail");

module.exports = function(media) {
    if (!media) {
        return ThumbnailPlaceholder;
    }

    switch (media.type) {
        case "album_track":
            return AlbumTrackThumbnail;
        case "artist_page":
            return ArtistThumbnail;
        case "audio":
            return AudioThumbnail;
        case "book":
            return BookThumbnail;
        case "brand":
            return BrandThumbnail;
        case "category":
            return CategoryThumbnail;
        case "external":
            return ExternalThumbnail;
        case "episode":
            return EpisodeThumbnail;
        case "issue":
            return IssueThumbnail;
        case "magazine":
            return MagazineThumbnail;
        case "music_album":
            return MusicAlbumThumbnail;
        case "page":
            return PageThumbnail;
        case "photo":
            return PhotoThumbnail;
        case "playlist_page":
            return PlaylistThumbnail;
        case "podcast":
            return PodcastThumbnail;
        case "podcast_episode":
            return PodcastEpisodeThumbnail;
        case "product_category":
            return ProductCategoryThumbnail;
        case "product":
            return ProductThumbnail;
        case "series":
            return SeriesThumbnail;
        case "video":
            return VideoThumbnail;
        case "view_more":
            return ViewMoreThumbnail;
        default:
            return ThumbnailPlaceholder;
    }
};
